import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProfileMenu: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    logout();
    setIsOpen(false);
    navigate('/login');
  };

  const handleManageAccount = () => {
    navigate('/manage-account');
    setIsOpen(false);
  };

  const handleManageBilling = () => {
    navigate('/manage-billing');
    setIsOpen(false);
  };

  // Get user initials for avatar
  const getInitials = (email: string) => {
    return email.charAt(0).toUpperCase();
  };

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-center w-8 h-8 bg-primary text-gray-900 rounded-full font-semibold hover:bg-opacity-90 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-surface-light dark:focus:ring-offset-background-card"
        aria-label="Profile menu"
      >
        {getInitials(user?.email || 'U')}
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 min-w-48 bg-white dark:bg-background rounded-md shadow-lg border border-border-light dark:border-border-color py-1 z-50">
          <div className="px-4 py-2 border-b border-border-light dark:border-border-color">
            <p className="text-sm font-medium text-text-light-primary dark:text-text-primary whitespace-nowrap">
              {user?.email}
            </p>
          </div>
          
          <button
            onClick={handleManageAccount}
            className="w-full text-left px-4 py-2 text-sm text-text-light-secondary dark:text-text-secondary hover:bg-gray-100 dark:hover:bg-border-color transition-colors duration-200"
          >
            Manage Account
          </button>

          <button
            onClick={handleManageBilling}
            className="w-full text-left px-4 py-2 text-sm text-text-light-secondary dark:text-text-secondary hover:bg-gray-100 dark:hover:bg-border-color transition-colors duration-200"
          >
            Manage Billing
          </button>
          
          <button
            onClick={handleLogout}
            className="w-full text-left px-4 py-2 text-sm text-text-light-secondary dark:text-text-secondary hover:bg-gray-100 dark:hover:bg-border-color transition-colors duration-200"
          >
            Log out
          </button>
        </div>
      )}
    </div>
  );
};

export default ProfileMenu;
